// @ts-nocheck
import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { DataWrapper } from "@/common/components/dataWrapper";
import Form from "@/common/components/form/Form";
import { Modal, ModalLevel2 } from "@/common/components/modal";
import { Prompt } from "@/common/components/prompt";
import { Preview } from "@/common/components/preview";
import { Button, H3 } from "@/common/elements";
import { ImageInput } from "./subs/ImageInput";
import { PackagingLevels } from "./subs/PackagingLevels";
import {
  ModalFormWrapper,
  ModalImageWrapper,
  ModalPreviewWrapper,
  ModalWrapper,
} from "./subs/style";

import { RiImageAddFill } from "react-icons/ri";

import { FilesObject, KeyValueObj, SelectOptions } from "@/common/types";
import { sleep } from "@/common/utils";
import useAxiosCall from "@/hooks/useAxiosCall";
import { useAuthDetails } from "@/hooks/useAuthDetails";
import { importerProductForm, manufacturerProductForm } from "../Data";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import {
  ADD_PRODUCT_URL,
  ATC_CODES_URL,
  GET_BRANDS_URL,
  PRODUCT_SETTINGS_URL,
  PRODUCT_URL,
} from "@/common/constants";
import { ClipSpinner } from "@/common/components/spinner";
import { ExistingImage } from "./subs/existing-image";
import { fitImageInSquareBox } from "@/common/utils/general";
import { default_z_index } from "@/common/data";
import { packagingHierarchyChanged } from "./subs/packaging-hierarchy";

export interface IProductFactoryProps {
  open: boolean;
  close: () => void;
  onSuccessfullMutation?: (data: KeyValueObj, done: boolean) => void;
  editMode?: boolean;
  product?: KeyValueObj;
  productType: string;
}

export function ProductFactory({
  open,
  close,
  onSuccessfullMutation,
  editMode,
  product,
  productType,
}: IProductFactoryProps) {
  const [retry, setRetry] = useState(0);
  const [actualForm, setActualForm] = useState<KeyValueObj[]>([]);
  const [files, setFiles] = useState<FilesObject>({});
  const [imageInputs, setImageInputs] = useState<string[]>([]);
  const [previewData, setPreviewData] = useState<KeyValueObj[]>([]);
  const [stage, setStage] = useState(1);
  const [modalTitle, setModalTitle] = useState("Product Details");
  const [modalSubtitle, setModalSubtitle] = useState(
    "Enter details of the product (fields marked with * are required)",
  );
  const [formValues, setFormValues] = useState<KeyValueObj>({});
  const [loading, setLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState(false);
  const [currentProduct, setCurrentProduct] = useState<KeyValueObj>({});
  const [currentImageUrl, setCurrentImageUrl] = useState("");
  const [mainFormValues, setMainFormValues] = useState<KeyValueObj>({});
  const [isMainFormValid, setIsMainFormValid] = useState(false);
  const [packagingValues, setPackagingValues] = useState<KeyValueObj>({});
  const [isPackagingValid, setIsPackagingValid] = useState(false);
  const [showPurgeConfirm, setShowPurgeConfirm] = useState(false);

  const [getProductSettings, baseSetting, baseError, baseLoading] =
    useAxiosCall();
  const [getAtcCodes, atcData, , atcLoading] = useAxiosCall();

  // const {
  //   data: atcData,
  //   error: atcError,
  //   loading: atcLoading,
  //   meta: atcMeta,
  // } = useQuery(ATC_CODES_URL);

  // const {
  //   data: atcData,
  //   error: atcError,
  //   loading: atcLoading,
  //   meta: atcMeta,
  // } = useQuery(PRODUCT_SETTINGS_URL);

  const { companyType } = useAuthDetails();
  const apiCall = useApiCallHandling();

  async function onBrandSelected(
    latestInput: string,
    name: string,
    updateValidity: (name: string, validity: boolean) => void,
    setFormValues: Dispatch<SetStateAction<KeyValueObj>>,
  ) {
    let tempLowerPart: any = [];

    if (latestInput === "Others(Specify)") {
      setActualForm((prev: KeyValueObj[]) => {
        const existingIndex = prev.findIndex(
          (formItem: KeyValueObj) =>
            formItem.inputType === "text" && formItem.name === "brand_name",
        );
        const index = prev.findIndex(
          (formItem: KeyValueObj) =>
            formItem.inputType === "selectInput" &&
            formItem.name === "brand_name",
        );

        const brandTextInput = {
          inputType: "text",
          prompt: "Product Brand",
          name: "brand_name",
          placeholder: "Type your product brand",
          fullWidth: false,
          shortWidth: true,
          rules: {
            minLength: {
              errorMessage: "should be at least 2 characters",
              expectedValue: 2,
            },
          },
        };

        if (existingIndex === -1) {
          prev.splice(index + 1, 0, brandTextInput);
          //The lower part is cut off so that the page can properly reload
          //the options
          tempLowerPart = prev.slice(2, prev.length);
          return prev.slice(0, 2);
        } else {
          prev.splice(existingIndex, 1, brandTextInput);
          //The lower part is cut off so that the page can properly reload
          //the options
          tempLowerPart = prev.slice(2, prev.length);
          return prev.slice(0, 2);
        }
      });

      //we need to make it invalid since a new thing now needs to be set
      updateValidity(name, false);
    } else {
      setActualForm((prev: any) => {
        const existingIndex = prev.findIndex(
          (formItem: KeyValueObj) =>
            formItem.inputType === "text" && formItem.name === "brand_name",
        );

        if (existingIndex !== -1) {
          prev.splice(existingIndex, 1);
          //The lower part is cut off so that the page can properly reload
          //the options
          tempLowerPart = prev.slice(2, prev.length);
          return prev.slice(0, 2);
        }
        return prev.slice();
      });
    }

    //Wait for few miliseconds
    setLoadingInputs(true);
    await sleep(200);

    //put back the onces cut off
    setActualForm((prev) => {
      return [...prev, ...tempLowerPart];
    });
    setLoadingInputs(false);
  }

  async function onATCSelected(
    latestInput: string,
    name: string,
    updateValidity: (name: string, validity: boolean) => void,
    setFormValues: Dispatch<SetStateAction<KeyValueObj>>,
  ) {
    //replace the options of brand with a loading state
    setActualForm((prev: KeyValueObj[]) => {
      const loadingInput = {
        inputType: "text",
        prompt: "Product Brand",
        name: "brand_name",
        options_name: "product_brand",
        readOnly: true,
        fullWidth: false,
        shortWidth: true,
        placeholder: "existing brands loading...",
        loadingState: true,
      };

      prev.splice(1, 1, loadingInput);
      return prev;
    });

    await apiCall(
      GET_BRANDS_URL + "?product_type=drug&atc_code_id=" + latestInput,
      "GET",
      {},
      (data: any) => {
        //replace now with actual options
        const existingBrand: KeyValueObj[] = [];
        data?.forEach((datum: KeyValueObj) => {
          existingBrand.push({
            id: datum.brand_name,
            title: datum.brand_name,
          });
        });
        setActualForm((prev: KeyValueObj[]) => {
          const index = prev.findIndex(
            (formItem: KeyValueObj) =>
              formItem.readOnly === true && formItem.name === "brand_name",
          );
          const brandInput = {
            prompt: "Select a brand",
            placeholder: "Select a brand from already existing list",
            inputType: "selectInput",
            name: "brand_name",
            options: [
              ...existingBrand,
              { id: 566576556, title: "Others(Specify)" },
            ],
            fullWidth: false,
            shortWidth: true,
            onEveryChange: onBrandSelected,
            indexLevel: default_z_index,
          };

          prev.splice(index, 1, brandInput);

          return prev.slice();
        });
      },
      (err: any) => {
        //replace now with actual options
        setActualForm((prev: KeyValueObj[]) => {
          const index = prev.findIndex(
            (formItem: KeyValueObj) =>
              formItem.readOnly === true && formItem.name === "brand",
          );
          const brandInput = {
            inputType: "text",
            prompt: "Product Brand",
            name: "brand_name",
            options_name: "product_brand",
            placeholder: "Select ATC code first",
            readOnly: true,
            fullWidth: false,
            shortWidth: true,
          };

          prev.splice(index, 1, brandInput);

          return prev.slice();
        });

        console.log(err);
      },
      () => {},
    );
  }

  useEffect(() => {
    // MED-688: this component is mounted unconditionally by its callers (the
    // Modal it renders into only hides content, it doesn't unmount it), so
    // without this guard these two calls fired on every page load even while
    // closed.
    if (!open) return;
    getProductSettings({ url: PRODUCT_SETTINGS_URL, method: "GET" });
    getAtcCodes({ url: ATC_CODES_URL, method: "GET" });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, retry]);

  //handling forms setup
  useEffect(() => {
    if (companyType && baseSetting.length) {
      const settings = baseSetting[0].values;

      let productForm:
        typeof manufacturerProductForm | typeof importerProductForm = [];

      if (companyType?.toLowerCase() === "manufacturer") {
        productForm = manufacturerProductForm;
      } else if (companyType?.toLowerCase() === "importer") {
        productForm = importerProductForm;
      }

      const modifiedForm = productForm.map(
        (formItem: KeyValueObj, index: number) => {
          //check if any of the form option_name match with one in the base settings,
          //if true, then replace the options with the one at baseSetting
          if (
            formItem?.inputType === "selectInput" &&
            settings[formItem.options_name]
          ) {
            formItem.indexLevel = default_z_index - index;

            // modify the content based on the base settings
            let options: SelectOptions[] = [];

            settings[formItem.options_name]?.forEach(
              (item: string, i: number) => {
                options.push({ id: i.toString(), title: item });
              },
            );
            const tempFormItem = { ...formItem };
            tempFormItem.options = options;
            return tempFormItem;

            //find the ATC codes and pass it onEveryChange function that will now fetch
            //the brands that alreay exist
          } else if (
            formItem?.inputType === "selectInput" &&
            formItem?.name === "atc_code_id"
          ) {
            formItem.indexLevel = default_z_index;
            const tempFormItem = { ...formItem };
            tempFormItem.onEveryChange = onATCSelected;
            tempFormItem.options = atcData;
            return tempFormItem;
          } else {
            return formItem;
          }
        },
      );

      //Update the form with initial data if it is in edit mode
      if (editMode && product) {
        const editForm = modifiedForm.map((formItem: KeyValueObj) => {
          //set initial values for the ones that will be read only
          if (formItem.name === "brand_name") {
            return {
              ...formItem,
              inputType: "text",
              readOnly: true,
              initialValue: product[formItem.name],
            };
          } else if (formItem.name === "atc_code_id") {
            // The ATC code is a classification and can be got wrong, so it stays
            // editable on edit — the re-approval cycle is what verifies the
            // change. It keeps its selectInput; only the value is seeded.
            //
            // The seed MUST be the uuid, not the code identifier: atc_code_id is
            // a uuid column, so sending "A000001" was cast to null by the API and
            // silently wiped the product's classification. The API now rejects a
            // non-uuid outright. `product.atc_code` is the full object (there is
            // no top-level atc_code_id in the response), hence `.id`.
            //
            // onATCSelected is dropped here: its job is to repopulate the brand
            // dropdown while creating a product, but on edit the brand is
            // read-only and identifies the product. Reclassifying must not
            // rewrite it.
            return {
              ...formItem,
              onEveryChange: undefined,
              initialValue: product?.atc_code?.id,
            };
          } else {
            return {
              ...formItem,
              initialValue: product[formItem.name],
            };
          }
        });
        setActualForm(editForm);
      } else {
        setActualForm(modifiedForm);
      }
    }

    //set the product in a state so that we can update it when it is changed
    product && setCurrentProduct(product);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseSetting, baseError, baseLoading, companyType, product, atcData]);

  const handlePackagingChange = (values: KeyValueObj, isValid: boolean) => {
    setPackagingValues(values);
    setIsPackagingValid(isValid);
  };

  const onFormContinue = () => {
    setFormValues({
      ...mainFormValues,
      ...packagingValues,
      name: mainFormValues?.brand_name,
    });
    setStage(2);
    setModalTitle("Product image upload");
    setModalSubtitle("Upload clear images of the product");
  };

  const onImageContinue = async () => {
    const formPreviewData: KeyValueObj[] = [];
    Object.keys(formValues).forEach((formKey: any) => {
      if (formKey === "packaging_layers") {
        const layers: KeyValueObj[] = formValues[formKey] || [];
        formPreviewData.push({
          name: "Product Packaging",
          type: "category",
          value: layers.map((entry: KeyValueObj, i: number) => {
            const childType = layers[i + 1]?.packaging_type;
            return {
              name: `Level ${i + 1} - ${entry.packaging_type}`,
              value:
                entry.containment_quantity !== undefined &&
                entry.containment_quantity !== null
                  ? `Holds ${entry.containment_quantity} ${childType || "unit"}(s)`
                  : "Smallest packaging unit",
            };
          }),
        });
        return;
      }
      // MED-656: formValues.atc_code_id holds the AtcCode row's raw id (Select
      // always returns id for valueType "ATC"), so the generic fallback below
      // would print that id on the review screen. Render the human-readable
      // "code — title" looked up from the already-fetched atcData options
      // instead.
      //
      // MED-651: edit mode seeds the field with that same id, so this lookup
      // now succeeds on both flows. (It previously seeded code_identifier from
      // a read-only branch that no longer exists, which matched no atcData id.)
      // currentProduct.atc_code remains as a fallback for when atcData has not
      // loaded, or does not contain this product's code.
      if (formKey === "atc_code_id") {
        const selectedAtc = (atcData || []).find(
          (option: KeyValueObj) => option.id === formValues[formKey],
        );
        const editAtc = currentProduct?.atc_code;
        formPreviewData.push({
          name: "ATC code",
          value: selectedAtc
            ? `${selectedAtc.code_identifier} — ${selectedAtc.code_title}`
            : editAtc
              ? `${editAtc.code_identifier} — ${editAtc.code_title}`
              : formValues[formKey],
        });
        return;
      }
      formPreviewData.push({
        name: formKey,
        value: formValues[formKey],
      });
    });

    const imagePreviewData = await Promise.all(
      Object.keys(files).map(async (formKey: string, i: number) => {
        const formattedImage = await fitImageInSquareBox(files[formKey], 600);
        setFiles((prev: any) => ({ ...prev, [formKey]: formattedImage }));
        return {
          name: "New Product Image " + (i + 1),
          value: formattedImage,
        };
      }),
    );

    const oldImageData: KeyValueObj[] = [];
    if (editMode) {
      currentProduct?.images?.forEach((image: KeyValueObj, i: number) => {
        oldImageData.push({
          type: "imageUrl",
          name: "Existing Image " + (i + 1),
          value: image.url,
        });
      });
    }

    setPreviewData([...formPreviewData, ...oldImageData, ...imagePreviewData]);

    console.log({ imagePreviewData });
    setModalTitle("Review your product");
    setModalSubtitle("");
    setStage(3);
  };

  const onPreviewBack = () => {
    setModalTitle("Details of item");
    setModalSubtitle("Enter details of the product you are trying to ship");
    setStage(2);
  };

  // MED-679: only a packaging-hierarchy change invalidates this product's stock —
  // batch quantities and serial chains are expressed in those levels. The backend
  // stays the authority on this; asking here just spares the user a bounce off
  // the review screen.
  const inventoryToPurge: number =
    currentProduct?.edit_eligibility?.inventory_count ?? 0;

  const onPreviewSubmit = async (
    formValues: KeyValueObj,
    files: KeyValueObj,
  ) => {
    const hierarchyChanged = packagingHierarchyChanged(
      formValues?.packaging_layers,
      currentProduct?.packaging_layers,
    );

    if (editMode && inventoryToPurge > 0 && hierarchyChanged) {
      setShowPurgeConfirm(true);
      return;
    }

    await submitProduct(formValues, files, false);
  };

  // The dialog stays open for the duration of the request so its button shows
  // progress, and closes once the outcome is known either way — success closes
  // the whole factory, failure leaves the user on the preview with a toast.
  const onPurgeConfirmed = async () => {
    await submitProduct(formValues, files, true);
    setShowPurgeConfirm(false);
  };

  const submitProduct = async (
    formValues: KeyValueObj,
    files: KeyValueObj,
    confirmPurge: boolean,
  ) => {
    setLoading(true);
    const formData = new FormData();

    //add form values
    Object.keys(formValues).forEach((formKey: string) => {
      if (formKey === "packaging_layers") {
        const layers: KeyValueObj[] = formValues[formKey] || [];
        // Rack only builds an Array from empty-bracket notation
        // (foo[][bar]) — indexed brackets (foo[0][bar]) produce a Hash
        // keyed by "0", "1", ... instead. Every entry must append
        // `packaging_type` first so Rack's parser can detect "this key
        // already exists on the last hash" and start a new array item.
        layers.forEach((entry: KeyValueObj) => {
          formData.append(
            `packaging_layers[][packaging_type]`,
            String(entry.packaging_type).toLowerCase(),
          );
          if (
            entry.containment_quantity !== undefined &&
            entry.containment_quantity !== null &&
            entry.containment_quantity !== ""
          ) {
            formData.append(
              `packaging_layers[][containment_quantity]`,
              String(entry.containment_quantity),
            );
          }
        });
      } else {
        formData.append(formKey, formValues[formKey]);
      }
    });

    //add image values
    Object.keys(files).forEach((fileKey: string) => {
      formData.append("images[]", files[fileKey]);
    });

    //add the product type
    formData.append("product_type", productType);

    // MED-651: explicit consent to destroy this product's stock. Only ever sent
    // when the user has confirmed the dialog above.
    if (confirmPurge) formData.append("confirm_purge", "true");

    const url = editMode
      ? ADD_PRODUCT_URL + "/" + currentProduct?.id
      : ADD_PRODUCT_URL;

    await apiCall(
      url,
      editMode ? "PUT" : "POST",
      formData,
      (data: any) => {
        setFormValues({});
        setFiles({});
        setStage(1);
        onSuccessfullMutation && onSuccessfullMutation(data, true);
      },
      (err: any) => {
        console.log(err);
      },
      () => {
        setLoading(false);
      },
    );
  };

  function hadleFileCancel(e: any, fileName: string) {
    setImageInputs((prev: any) => {
      const temp = [...prev];
      temp.splice(temp.indexOf(fileName), 1);

      return temp;
    });
    delete files[fileName];
  }

  function deleteProductImage(imageId: string) {
    setCurrentImageUrl(imageId);
    apiCall(
      `${PRODUCT_URL}/${product?.id}/images/${imageId}`,
      "DELETE",
      {},
      (data: any) => {
        const copy = { ...currentProduct };
        const copyImage = [...copy.images];
        copy.images = copyImage.filter(
          (image: KeyValueObj) => image?.id !== imageId,
        );
        setCurrentProduct(copy);
        onSuccessfullMutation && onSuccessfullMutation(copy, false);
      },
      (error: any) => {
        console.log(error);
      },
      () => {
        setCurrentImageUrl("");
      },
    );
  }

  const handleAddMore = () =>
    setImageInputs((prev) => [...prev, "image_" + new Date().getTime()]);

  return (
    <>
      <Modal
        title={modalTitle}
        subTitle={modalSubtitle}
        isOpen={open}
        close={close}
      >
        <ModalWrapper stage={stage}>
          <ModalFormWrapper stage={stage}>
            <DataWrapper
              loading={baseLoading || atcLoading}
              error={baseError}
              failedMessage="Error loading form data. Click the button below to retry"
              loadingMessage="Loading form data..."
              onFailAction={() => setRetry((prev) => prev + 1)}
            >
              <Form
                loadingState={loadingInputs}
                formInputs={actualForm}
                processInputs={() => {}}
                spinnerComponent={<ClipSpinner />}
                login={false}
                biControl={false}
                handleBack={undefined}
                removeSubmitButton
                externalUpdateData={(name, value) =>
                  setMainFormValues((prev) => ({ ...prev, [name]: value }))
                }
                externalSetIsFormValid={setIsMainFormValid}
              />
              <PackagingLevels
                onChange={handlePackagingChange}
                editMode={editMode}
                product={product}
              />
              <div className="stage-one-submit">
                <Button
                  disabled={!isMainFormValid || !isPackagingValid}
                  onClick={onFormContinue}
                >
                  Continue
                </Button>
              </div>
            </DataWrapper>
          </ModalFormWrapper>
          <ModalImageWrapper stage={stage}>
            {editMode && currentProduct?.images?.length > 0 && (
              <div className="existing-images-wrapper">
                <div className="text-prompt">
                  <H3>Existing Images</H3>
                </div>
                <div className="existing-images">
                  {currentProduct?.images?.map((image: KeyValueObj) => (
                    <ExistingImage
                      key={image?.attachment_data?.id}
                      deleteImage={deleteProductImage}
                      imageUrl={image?.url}
                      imageId={image?.id}
                      currentImageUrl={currentImageUrl}
                      canDelete={currentProduct?.images?.length > 1}
                    />
                  ))}
                </div>
                {/* <div className="delete-all">
                <Button
                  onClick={deleteAllProductImages}
                  secondary
                  borderColor="danger"
                  color="danger"
                  disabled={currentImageUrl === "all"}
                >
                  {currentImageUrl === "all" ? (
                    <ClipSpinner />
                  ) : (
                    "Delete All Images"
                  )}
                </Button>
              </div> */}
              </div>
            )}
            <div className="image-inputs">
              <div className="add-more">
                <Button secondary onClick={handleAddMore}>
                  {" "}
                  <RiImageAddFill className="addmore-icon" /> Add more
                </Button>
              </div>
              <ImageInput name={"default1"} setFiles={setFiles} files={files} />
              <ImageInput name={"default2"} setFiles={setFiles} files={files} />
              {/* ADDED Images inputs */}
              {imageInputs?.map((inputName: string, i: number) => (
                <ImageInput
                  key={i}
                  name={inputName}
                  setFiles={setFiles}
                  files={files}
                  cancelable={true}
                  onFileCancel={hadleFileCancel}
                />
              ))}

              <div className="image-controls flex-row">
                <Button secondary onClick={() => setStage(1)}>
                  Back
                </Button>
                <Button
                  disabled={editMode ? false : Object.keys(files).length < 2}
                  onClick={onImageContinue}
                >
                  Continue
                </Button>
              </div>
            </div>
          </ModalImageWrapper>
          <ModalPreviewWrapper stage={stage}>
            <Preview
              data={previewData}
              biControl
              onBack={onPreviewBack}
              loading={loading}
              onSubmit={() => onPreviewSubmit(formValues, files)}
            />
          </ModalPreviewWrapper>
        </ModalWrapper>
      </Modal>

      {/* MED-651: purge confirmation. A sibling of the factory modal, not a
          child: it renders through the level-2 portal so it stacks above
          regardless of tree position, and Modal accepts a single child. */}
      <ModalLevel2
        isOpen={showPurgeConfirm}
        close={() => setShowPurgeConfirm(false)}
        title="Confirm inventory purge"
      >
        <Prompt
          type="delete"
          prompt={`Changing the packaging hierarchy will permanently purge ALL existing inventory for this product — every batch and every serial (${inventoryToPurge} ${
            inventoryToPurge === 1 ? "batch" : "batches"
          }). This cannot be undone.`}
          mainActionText="Purge and save"
          secondaryActionText="Cancel"
          mainLoading={loading}
          onMainAction={onPurgeConfirmed}
          onSecondaryAction={() => setShowPurgeConfirm(false)}
        />
      </ModalLevel2>
    </>
  );
}
